export const OLDER_VEHICLE_THRESHOLD = 2013;

export const NEWER_OLDER_SELECTION = 'newerOlder';
